/* @jsx jsx */
import { jsx } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

import * as React from 'react';

import { InlineNotification } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

type Props = {
  styles: SerializedStyles;
};

const UnknownAvailabilityNotification: React.VFC<Props> = ({ styles }) => (
  <InlineNotification severity="information" css={styles}>
    {_t('Availability for unconfirmed courses will be updated before enrollment begins.')}
  </InlineNotification>
);

export default UnknownAvailabilityNotification;
